<mat-dialog-content>
  <section class="w3l-hero-headers-11 p-sticky-md">
    <div class="top-header">
        <div class="d-grid grid-columns-top-3">
            <div class="accounts">
                <ul>
                    <li></li>
                    <li></li>
                </ul>
            </div>
            <div class="search">
                <form action="search-results.html" method="get">
                    <input id="search1" name="search1" type="text" [(ngModel)]="patientcode" (change)="retriveExaminationLookupTop_Patient()"  placeholder="Patient Code" >
                    <label>                      </label>
                    <input id="search2" name="search2" type="text" [(ngModel)]="paName" (change)="retriveExaminationLookupTop_Patient()" placeholder="Patient Name">
                    <label>                      </label>
                    <input id="search3" name="search3" type="date" [(ngModel)]="dateentry" (change)="retriveExaminationLookupTop_Patient()" >

                </form>
            </div>
        </div>
    </div>
  </section>

  <table>
    <thead>
        <tr >
            <th style="width: 20%;">Patient Code</th>
            <th style="width: 50%;">Patient Name</th>
            <th style="width: 800%;" >Examination Date</th>
            <th style="width: 20%;">Choose</th>
        </tr>
    </thead>
    <tbody>
      <tr *ngFor="let Do of examinationList; let i = index">
            <td data-column="Patient ID">{{Do.patientcode}}</td>
            <td data-column="Patient Name">{{Do.paName}}</td>
            <td data-column="Examination Date" style="text-align: center;">{{Do.dateentry}}</td>

            <td data-column="Choose"><button type="button" class="theme-button btn" id="select" name="select" (click)="SelectExaminition(Do)">Select</button>
            </td>
        </tr>

    </tbody>
  </table>
  </mat-dialog-content>
